export default "__VITE_ASSET__f49953e9__"